module.exports = __webpack_public_path__ + "static/media/1_en.268803a3.png";